import { createI18n } from 'vue-i18n';
import es from './es';
import en from './en';
import {
  DEFAULT_LANGUAGE,
  normalizeLanguage,
  SUPPORTED_LANGUAGES,
} from '../../shared/language';
import type { Language } from '../../shared/language';

export { normalizeLanguage, SUPPORTED_LANGUAGES };
export type { Language };

export default createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: { es, en },
});
